import Box from '@mui/material/Box';
import { Outlet, useLocation } from 'react-router-dom';
import { TravelerProfileGate } from '@/features/auth/components/TravelerProfileGate';
import { RoleSurfaceGate } from '@/shared/components/RoleSurfaceGate';
import { Navbar } from '@/shared/components/Navbar';
import { Footer } from '@/shared/components/Footer';
import { isAssistantEnabled } from '@/features/assistant/config';
import { TrplinAssistant } from '@/features/assistant/components/TrplinAssistant';

/**
 * The traveler surface. Guide applicants are travelers with an application
 * attached, so this layout stays open to them; `GuideLifecycleGate` arbitrates
 * the guide-lifecycle screens themselves.
 */
export function AppLayout() {
  const location = useLocation();

  return (
    <RoleSurfaceGate surface="traveler">
      <TravelerProfileGate />
      <Box sx={{ bgcolor: 'background.default', minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <Box component="main" sx={{ flex: 1, width: '100%' }}>
          <Outlet />
        </Box>
        <Footer />
        {isAssistantEnabled() ? (
          <TrplinAssistant context="TRAVELLER" page={location.pathname} />
        ) : null}
      </Box>
    </RoleSurfaceGate>
  );
}
